export class SavedPrinterDocumentDataEvent {
  constructor(
    /** IdInvoice */
    public invoiceId: number,
  ) {}
}
